import { postRequest } from '../clients/axios';
import { TransferClubsPayload } from '../models/TransferClubsPayload';

export const postTransferClubs = async (data: TransferClubsPayload) => {
  const url = 'tourbag/TransferClubs';
  const response = await postRequest<{ item1: string; item2: string }[]>(url, data);
  return response;
};
